<body *ngIf="!isLabSelected">
	<p-blockUI [blocked]="blocked" styleClass="absolute z-5">
		<p-progressSpinner [style]="{width: '100px', height: '200px'}" strokeWidth="6"></p-progressSpinner>
	</p-blockUI>
	<div class="container">
		<div class="row">
			<div class="col-sm-9 col-md-7 col-lg-5 mx-auto">
				<div class="card card-signin my-5">
					<div class="card-body">
						<div class="text-center">
							<img src="assets/BB_eurofins_icon.png" alt="BB_eurofins_icon">
						</div>
						<div *ngIf="yetToSelectLab">
							<div class="form-group">
								<h4 class="first">Lab</h4>
								<p-dropdown [options]="labs" [(ngModel)]="selectedLab" placeholder="Select a Lab" optionLabel="label" [showClear]="true"
								 [required]="true" [style]="{'width':'100%'}"></p-dropdown>
							</div>
							<button class="btn btn-primary btn-block text-uppercase processButton"
								(click)="assignLabAndLoad($event)">Proceed</button>
						</div>
						<div *ngIf="hasUISelection">
							<div class="form-group">
								<h4 class="first">Select UI:</h4>
								<div class="flex justify-content-around">
									<button class="btn btn-primary btn-block text-uppercase mx-2 col"
										(click)="selectUI(true)">NEW</button>
									<button class="btn btn-primary btn-block text-uppercase mx-2 col"
										(click)="selectUI(false)">OLD</button>	
								</div>
							</div>
						</div>
						<div *ngIf="hasArrayAndNGSSwitchOn">
							<h4 class="first">Process:</h4>
							<button class="btn btn-primary btn-block text-uppercase processButton"
								(click)="openProcess('ARRAY')">Array</button>
							<button class="btn btn-primary btn-block text-uppercase processButton"
								(click)="openProcess('NGS')">NGS</button>
						</div>
						<div *ngIf="azureLoginStatus" style="text-align: center;">
							<hr class="my-4">
							Logged in as <span style="font-weight: bold;">{{loggedUserName}}</span>
							<br>
							<a class="logOutLink" (click)="azureLogOut()">
								Login as a different User
							</a>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</body>